import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { SectionLabel } from "@/lib/ui";
import Header from "@/components/site/Header";
import { Footer } from "@/components/site/Sections3";
import FloatingActions from "@/components/site/FloatingActions";

export default function LegalLayout({ label, title, updated, sections }) {
  const { t } = useLang();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-slate-950 text-slate-100 selection:bg-blue-600">
      <Header />
      <main className="pt-36 md:pt-40 pb-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-400 hover:text-sky-400 transition-colors">
            <ArrowLeft className="h-4 w-4" /> {t({ ro: "Înapoi la pagina principală", en: "Back to homepage" })}
          </Link>

          <div className="mt-8">
            <SectionLabel>{t(label)}</SectionLabel>
            <h1 className="mt-5 font-display text-4xl md:text-5xl font-extrabold tracking-tighter">{t(title)}</h1>
            <p className="mt-4 text-sm text-slate-500">{t({ ro: "Ultima actualizare: ", en: "Last updated: " })}{updated}</p>
          </div>

          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display text-xl md:text-2xl font-bold tracking-tight">{t(s.h)}</h2>
                <div className="mt-3 space-y-3 text-slate-400 leading-relaxed">
                  {s.p.map((p, j) => (
                    <p key={j}>{t(p)}</p>
                  ))}
                  {s.list && (
                    <ul className="mt-2 list-disc pl-5 space-y-1.5">
                      {s.list.map((l, k) => (
                        <li key={k}>{t(l)}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
